<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body">
      <div class="row">
        <div
            class="col-md-12 text-center modal-header px-5 align-items-center"
        >
          <div class="header-container row w-100">
            <h3 v-if="!advancedModalOpen" class="col-11 text-left ml-3">{{modalTitle}}</h3>
            <h3 v-else class="col-11 text-left ml-3">More options</h3>
            <button class="close close-btn text-right col-1" @click="routeTo('back')">
              <img src="../../assets/images/icon-close.svg">
            </button>
          </div>
        </div>
      </div>

      <div class="pb-4">
        <div  v-if="!advancedModalOpen" class="row modal-body pl-5 pr-5 mb-2">
        <div class="col-md-6 col-12" v-for="(data, index) in paymentQuestions" :key="index" >
          <div class="payment-card" @click="routeTo(data.routeTo)" v-if="data.showBtn">
            <div class="payment-card-content">
              <div class="modal-card-anchor">
                {{data.question}}
              </div>
              <div class="modal-description">
                {{data.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
          <div v-if="filteredPaymentOptions.length> 0 && !advancedModalOpen" class="row modal-body pl-5 pr-5">
            <div class="col-12">
              <a class="more-options-link" @click="loadAdvancedPaymentModal">Please click for more options</a>
            </div>
        </div>
      </div>

      <div v-if="advancedModalOpen">
        <div class="row no-gutters align-back-button">
          <div class="col-12">
                      <span @click="navigateToBackPage" class="solution-link " >
                        <font-awesome-icon icon="arrow-left" size="sm"/>
                          Back
                      </span>
          </div>
        </div>
        <div class="row modal-body pl-5 pr-5 pb-5">
          <div class="col-md-6 col-12" v-for="(data, index) in filteredPaymentOptions" :key="index" >
            <div class="adv-options-card" :class="index > 1 ? 'mt-5':null" @click="routeTo(data.routeTo)">
              <div class="modal-card-anchor">
                {{data.question}}
              </div>
              <div class="modal-description">
                {{data.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/store/constants";
import FORM_LABELS from "@/store/FormLabels";
import { mapGetters } from "vuex"
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import WebFormsAccessMixin from "@/mixins/WebFormsAccessMixin";

export default {
  name: "SubmitPaymentModal",
  mixins: [PaymentFormsMixin, WebFormsAccessMixin],
  computed: {
    ...mapGetters(["isModalOpenFromBreadcrumbBtn","currentUser"]),
    modalTitle() {
      return this.isModalOpenFromBreadcrumbBtn ? FORM_LABELS.SUBMIT_AN_INVOICE:FORM_LABELS.VIEW_PURCHASE_ORDERS_INVOICE_MODAL_TITLE
    }
  },
  mounted() {
    this.validateRoute()
    this.checkForUserDepartment()
  },
  data() {
    return {
      advancedModalOpen: false,
      filteredPaymentOptions: [],
      FORM_LABELS: FORM_LABELS,
      paymentQuestions: [
        {
          question: 'View purchase orders',
          description: FORM_LABELS.VIEW_PURCHASE_ORDERS_DESC,
          routeTo: CONSTANTS.PURCHASE_ORDERS_TABLE_ROUTE,
          showBtn: true
        },
        {
          question: 'View invoices',
          description: FORM_LABELS.VIEW_INVOICES_DESC,
          routeTo: CONSTANTS.INVOICES_TABLE_ROUTE,
          showBtn: true
        },
        {
          question: FORM_LABELS.INVOICE_SUBMISSION_FORM_TITLE,
          description: FORM_LABELS.SUBMIT_AN_INVOICE_DESC,
          routeTo: CONSTANTS.INVOICE_SUBMISSION_FORM,
          showBtn: true
        },
        {
          question: FORM_LABELS.OTV_FORM_TITLE,
          description: FORM_LABELS.OTV_FORM_DESC,
          routeTo: CONSTANTS.ONE_TIME_SUPPLIER_PAYMENT,
          showBtn: true
        },
      ]
    }
  },
  methods: {
    routeTo(route) {
      //Routing is handled by ShowSubmitPaymentModal.vue
      this.$parent.$emit('closed', route)
    },
    validateRoute() {
      this.paymentQuestions.forEach(question => {
        //Hide 'view POs' and 'view Invoices' option when modal opened from breadcrumb btn
        if(question.description === FORM_LABELS.VIEW_PURCHASE_ORDERS_DESC
            || question.description === FORM_LABELS.VIEW_INVOICES_DESC) {
          if(this.isModalOpenFromBreadcrumbBtn) {
            question.showBtn = false
          }
        }
      })
    },
    checkForUserDepartment() {
      this.filteredPaymentOptions = this.advancedPaymentOptions.filter((paymentOption)=>paymentOption.displayForm === true)
    },
    loadAdvancedPaymentModal(){
      if (this.filteredPaymentOptions.length > 0){
        this.advancedModalOpen = true
      }
    },
    navigateToBackPage(){
      this.advancedModalOpen = false
    }
  }
}
</script>

<style scoped>

.modal-card-anchor {
  color: #000 !important;
  cursor: pointer;
  font-family: "artifaktElementBold";
}

.payment-card:hover {
  background: #f0f3f4;
}

.modal-description {
  font-size: 16px;
  font-family: artifaktElementRegular !important;
}

.align-back-button{
  padding-left: 45px;
}

.more-options-link {
  text-decoration: underline;
  color: #666;
  font-size: 16px;
}

.payment-card {
  padding: 30px;
  margin-top: 30px;
  border: 1px solid gray;
  cursor: pointer;
  height: 140px;
}

.adv-options-card {
  padding: 30px;
  border: 1px solid gray;
  cursor: pointer;
  height: 140px;
}

.modal-container {
  overflow-y: auto !important;
  height: 100%;
  overflow-x: hidden;
}

.payment-card-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

@media screen and (max-width: 576px) {
  .adv-options-card {
    height: 200px;
    margin-top: 3rem;
  }
}

@media screen and (max-width: 576px) {
  .payment-card {
    padding: 10px;
  }
  h3{
    font-size:18px;
  }
}

</style>